export default function Button({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  icon = null,
  iconPosition = 'left',
  fullWidth = false,
  onClick,
  children,
  type = 'button',
  style,
  ...rest
}) {
  const classes = [
    'tg-btn',
    `tg-btn--${variant}`,
    `tg-btn--${size}`,
    loading ? 'is-loading' : '',
    disabled ? 'is-disabled' : '',
  ].filter(Boolean).join(' ')

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || loading}
      onClick={onClick}
      style={{ width: fullWidth ? '100%' : undefined, ...style }}
      {...rest}
    >
      <span className="tg-spinner" aria-hidden="true" />
      {icon && iconPosition === 'left' && icon}
      {children}
      {icon && iconPosition === 'right' && icon}
    </button>
  )
}
